import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-content" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = {
  key: 0,
  class: "api-error"
}
const _hoisted_6 = { class: "package-list" }
const _hoisted_7 = { class: "package-card" }
const _hoisted_8 = { class: "package-header" }
const _hoisted_9 = { class: "package-name-section" }
const _hoisted_10 = { class: "package-title text-capitalize" }
const _hoisted_11 = { class: "package-highlight" }
const _hoisted_12 = { class: "package-actions" }
const _hoisted_13 = { class: "package-features" }
const _hoisted_14 = { class: "features-list" }
const _hoisted_15 = { class: "feature-text" }
const _hoisted_16 = { class: "package-pricing" }
const _hoisted_17 = { class: "pricing-grid" }
const _hoisted_18 = { class: "pricing-card" }
const _hoisted_19 = { class: "pricing-amount" }
const _hoisted_20 = { class: "selected-hint" }

import { computed, ref, watch } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AddSchedulePackageModal from "@/modules/vendor/components/profile-setup/AddSchedulePackageModal.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";

type PackagePricing = {
  type: string;
  amount: number;
};

type Package = {
  id?: number | string;
  name: string;
  highlight: string;
  features: string;
  price?: number | string;
  package_type?: "one_time" | string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulePackageStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const modal = useModalStore();

const packages = ref<Package[]>([]);
const search = ref("");
const serverError = ref("");

watch(
  () => props.profileInfo,
  (info) => {
    const apiPkg = info?.schedule_packages ?? null;
    const list = Array.isArray(apiPkg) ? apiPkg : apiPkg ? [apiPkg] : [];
    if (!list.length) return;
    if (packages.value.length) return;

    const mapped = list
      .map((item: any) => {
        const packageType = String(item?.package_type ?? "").trim().toLowerCase();
        const rawPricing = Array.isArray(item?.pricing) ? item.pricing : [];
        const pricing: PackagePricing[] = rawPricing
          .map((p: any) => {
            const type = String(p?.type || "").trim();
            const amount = Number(p?.amount ?? 0);
            if (!type) return null;
            return {
              type,
              amount: Number.isFinite(amount) ? amount : 0,
            } as PackagePricing;
          })
          .filter(Boolean) as PackagePricing[];

        const price = Number(item?.price ?? item?.one_time_price ?? pricing?.[0]?.amount ?? 0);
        const isOneTime =
          packageType === "one_time" ||
          packageType === "one-time" ||
          (pricing.length === 1 && pricing[0]?.type === "one_time") ||
          (Number.isFinite(price) && price > 0 && pricing.length === 0);

        if (!isOneTime) return null;

        const name = String(item?.name || "").trim();
        if (!name) return null;

        return {
          id: item?.id,
          name,
          highlight: String(item?.highlight || "").trim(),
          features: String(item?.feature || item?.features || "").trim(),
          price: Number.isFinite(price) ? price : 0,
          package_type: "one_time",
        } as Package;
      })
      .filter(Boolean) as Package[];

    packages.value = mapped;
  },
  { immediate: true }
);

const filteredPackages = computed(() => {
  const q = search.value.trim().toLowerCase();
  if (!q) return packages.value;
  return packages.value.filter((pkg) => {
    return (
      pkg.name.toLowerCase().includes(q) ||
      pkg.highlight.toLowerCase().includes(q) ||
      pkg.features.toLowerCase().includes(q)
    );
  });
});

watch(
  () => props.errors,
  (errs: any) => {
    serverError.value = "";
    if (!errs) return;

    const root = errs?.errors && typeof errs.errors === "object" ? errs.errors : errs;
    const schedulePackageErr = root?.schedule_package ?? root?.package_list ?? root?.packages;
    if (schedulePackageErr) {
      serverError.value = Array.isArray(schedulePackageErr)
        ? schedulePackageErr.join(" ")
        : String(schedulePackageErr);
      return;
    }

    if (typeof errs.message === "string" && errs.message.trim()) {
      serverError.value = errs.message;
    }
  },
  { immediate: true }
);

function getValues() {
  return {
    id: packages.value?.[0]?.id,
    schedule_packages: packages.value,
    search: search.value,
  };
}

__expose({ getValues });

function openAddPackageModal() {
  modal.open(
    AddSchedulePackageModal,
    {
      onAdd: (pkg: Package) => {
        packages.value = [...packages.value, pkg];
      },
    },
    { fullscreen: true, title: "Add Schedule Package", showHeader: false }
  );
}

function deletePackage(index: number) {
  packages.value.splice(index, 1);
}

function formatPrice(pkg: Package): string {
  const price = Number(pkg.price ?? 0);
  return Number.isFinite(price) ? String(price) : "0";
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppButtonFlat, {
          color: "primary",
          block: "",
          variant: "outlined",
          "prepend-icon": "mdi-plus",
          onClick: openAddPackageModal
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Create schedule package ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "title text-success" }, " Create fixed-price packages for scheduled services. You can customize details later. ", -1)),
    _createElementVNode("div", _hoisted_4, [
      (serverError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(serverError.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPackages.value, (pkg, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pkg.id ?? index,
          class: "package-item"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(pkg.name), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(pkg.highlight), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "text",
                  icon: "mdi-delete",
                  color: "error",
                  onClick: ($event: any) => (deletePackage(index)),
                  class: "delete-btn"
                }, null, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pkg.features.split(','), (feature) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: feature,
                    class: "feature-item"
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "#10b981",
                      class: "feature-icon"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-check-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(feature.trim()), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "pricing-header" }, [
                _createElementVNode("span", { class: "pricing-label" }, "Fixed Price")
              ], -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pricing-type" }, "One-time", -1)),
                  _createElementVNode("div", _hoisted_19, "$" + _toDisplayString(formatPrice(pkg)), 1)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[4] || (_cache[4] = _createTextVNode(" Total packages: ", -1)),
      _createElementVNode("strong", null, _toDisplayString(packages.value.length), 1)
    ])
  ]))
}
}

})